<template>
  <div id="nxin" class="nxin" v-if="loaded">
    <!--<van-nav-bar safe-area-inset-top />-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件 -->
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- <router-view /> -->
    <!-- 开启底部安全区适配 -->
    <!-- 适配iPhone X 等机型底部存在底部指示条 -->
    <van-number-keyboard safe-area-inset-bottom />
    <!--<Aside v-if="hide" />-->
    <!--<section class="layout">-->
      <!--&lt;!&ndash;<Header v-if="hide" />&ndash;&gt;-->
      <!--<main class="layout-content">-->
        <!--111111111111-->
        <!--<van-button type="primary">主要按钮</van-button>-->
        <!--&lt;!&ndash;<router-view />&ndash;&gt;-->
      <!--</main>-->
    <!--</section>-->
  </div>
</template>

<style lang="scss">
  body {
    color: #333;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    line-height: 1.5;
    background-color: #f0f2f5;
  }
  * {
    box-sizing: border-box;
  }
  .nxin {
    width: 100%;
    height: 100%;
    /*flex: auto;
    display: flex;
    flex-direction: row;*/
  }
  .layout {
    flex: auto;
    display: flex;
    min-height: 100vh;
    overflow-x: hidden;
    transition: all .2s;
    flex-direction: column;
  }
  .layout-content {
    margin: 24px;
  }
</style>
<script>
// import Header from '@/components/Header';
// import Aside from '@/components/Aside';

export default {
  name: "App",
  components: {
    // Aside,
    // Header,
  },
  data() {
    return {
      loaded: false
    };
  },
  computed: {
    hide() {
      const {
        query: {
          hide
        }
      } = this.$route;

      // 是否隐藏头部和菜单
      if (hide === "true") {
        return false;
      }
      return true;
    }
  },
  created() {
    // 用户信息
    this.loaded = true;
    this.$store.dispatch("app/getUserIdentity");
  }
};
</script>
